// extracted by mini-css-extract-plugin
export default {"homewrap":"Heading_homewrap__UQ0FL","mottowrap":"Heading_mottowrap__qg2nM","labellight":"Heading_labellight__WVYEE","heading":"Heading_heading__2J5hE"};